import { ThemedText } from "@/components/ThemedText";
import { ThemedView } from "@/components/ThemedView";
import auth from "@react-native-firebase/auth";
import { StatusBar } from "expo-status-bar";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Button, StyleSheet, TextInput } from "react-native";

const ForgotPasswordScreen = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handlePasswordReset = async () => {
    if (email.trim() === "") {
      Alert.alert(t("ERROR"), t("PLEASE_ENTER_EMAIL"));
      return;
    }
    setLoading(true);
    try {
      await auth().sendPasswordResetEmail(email);
    } catch (error: any) {
      if (error.code !== "auth/user-not-found") {
        Alert.alert("Error", error.message);
        setLoading(false);
        return;
      }
    }

    Alert.alert(t("SUCCESS"), t("IF_ACCOUNT_EXISTS"));
    setLoading(false);
  };

  return (
    <ThemedView style={styles.container}>
      <StatusBar style="dark" animated={true} />
      <ThemedText style={styles.title}>{t("FORGOT_PASSWORD")}</ThemedText>
      <TextInput
        style={styles.input}
        placeholder={t("EMAIL")}
        keyboardType="email-address"
        autoCapitalize="none"
        placeholderTextColor="#888"
        value={email}
        onChangeText={setEmail}
      />
      <Button
        title={loading ? t("SENDING") : t("RESET_PASSWORD")}
        onPress={handlePasswordReset}
        disabled={loading}
      />
    </ThemedView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    padding: 16,
  },
  title: {
    fontSize: 24,
    marginBottom: 16,
    textAlign: "center",
  },
  input: {
    width: "100%",
    maxWidth: 350,
    height: 48,
    borderColor: "#ccc",
    borderWidth: 1,
    borderRadius: 8,
    paddingHorizontal: 12,
    marginBottom: 16,
    fontSize: 16,
    backgroundColor: "#fafafa",
    color: "#000",
  },
});

export default ForgotPasswordScreen;
